var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"title is-2"},[_vm._v(_vm._s(_vm.$t('Change log')))]),_c('div',{ref:"md",staticClass:"content from-markdown"})])
}
var staticRenderFns = []

export { render, staticRenderFns }